import "./TfsaPlanner.module.css";
import VoltMainHeader from "@/reusable_sections/Header";
import LeadQualificationForm from "./sections/LeadQualificationForm";
import FaqSection from "./sections/FaqSection";
import Footer from "@/reusable_sections/Footer";
export default function TfsaPlannerPage() {
  return <div>
      <VoltMainHeader />
      <LeadQualificationForm />
      <FaqSection />
      <Footer />
    </div>;
}